import { useOrgContext } from '@/org/contexts/OrgContext'
import React, { useEffect, useState } from 'react'
import { isOrgFresh } from '../isOrgFresh'
import OrgSetupModal from '../modals/OrgSetupModal'

// Opens the org-setup step for a freshly created org, one that hasn't been set
// up yet (see isOrgFresh). Derived from the already-subscribed org data, so it
// needs no extra query and survives reloads. Once opened it stays open until
// the user finishes (seeding changes the data, which would otherwise flip the
// condition mid-flow).
export default function OrgSetupTrigger() {
  const { orgData } = useOrgContext()
  const isFresh = isOrgFresh(orgData)

  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (isFresh) setOpen(true)
  }, [isFresh])

  if (!open) return null

  return <OrgSetupModal onClose={() => setOpen(false)} />
}
